"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.map.js");
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _formElements = require("@evidation/form-elements");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _validations = _interopRequireDefault(require("./validations"));
var _excluded = ["ranking_component_answers", "min_value", "max_value", "schemaHasHeading", "numberOfInputs", "hint_text", "label", "name"];
var RankingComponent = function RankingComponent(_ref) {
  var ranking_component_answers = _ref.ranking_component_answers,
    min_value = _ref.min_value,
    max_value = _ref.max_value,
    schemaHasHeading = _ref.schemaHasHeading,
    numberOfInputs = _ref.numberOfInputs,
    hint_text = _ref.hint_text,
    label = _ref.label,
    name = _ref.name,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var rankingRange = function rankingRange(min_value, max_value) {
    var list = [];
    for (var index = Number(min_value); index <= Number(max_value); index++) {
      list.push({
        value: index,
        label: "".concat(index)
      });
    }
    return list;
  };
  var ranges = rankingRange(min_value, max_value);
  var OptionsContainer = _styledComponents["default"].div.withConfig({
    displayName: "ranking_component__OptionsContainer"
  })(["align-items:center;display:flex;padding:5px;"]);
  var OptionRange = _styledComponents["default"].div.withConfig({
    displayName: "ranking_component__OptionRange"
  })(["margin-right:5px;"]);
  var OptionDescription = _styledComponents["default"].div.withConfig({
    displayName: "ranking_component__OptionDescription"
  })([""]);
  return /*#__PURE__*/_react["default"].createElement("div", null, !schemaHasHeading && numberOfInputs === 1 ? /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleLegend, {
    schemaHasHeading: schemaHasHeading,
    numberOfInputs: numberOfInputs
  }, (0, _utils.stripHtml)(label)) : /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "id_".concat(name),
    className: "basic-label"
  }, (0, _utils.stripHtml)(label || '')), hint_text ? /*#__PURE__*/_react["default"].createElement(_formElements.HintText, {
    text: hint_text
  }) : null, ranking_component_answers === null || ranking_component_answers === void 0 ? void 0 : ranking_component_answers.map(function (ranking_component_answer) {
    return /*#__PURE__*/_react["default"].createElement(OptionsContainer, null, /*#__PURE__*/_react["default"].createElement(OptionRange, null, /*#__PURE__*/_react["default"].createElement(_formElements.SelectInput, {
      "data-test-id": "raking-copmponent-option-".concat(ranking_component_answer.identifier),
      required: true,
      options: ranges,
      convertValuesToStrings: false
    })), /*#__PURE__*/_react["default"].createElement(OptionDescription, {
      key: ranking_component_answer.identifier
    }, (0, _utils.stripHtml)(ranking_component_answer.label)));
  }));
};
var _default = exports["default"] = RankingComponent;